export default "__VITE_ASSET__Dkg1Hm_K__"